<template>
  <div
    class="d-flex flex-row w-100 justify-content-between align-items-center py-2"
  >
    <div
      style="font-size: 1.3rem"
      class="text-capitalize"
      v-text="separador(breads)"
    ></div>

    <!-- v-text="
        breads[breads.length - 1].includes('_')
          ? separador(breads[breads.length - 1])
          : breads[breads.length - 1]
      " -->

    <div v-if="breads" class="d-flex text-capitalize justify-content-end">
      <div
        :style="
          index > 0
            ? [{ 'padding-left': '7px', color: '#6c757d' }]
            : [{ 'font-weight': 400 }]
        "
        v-for="(bread, index) in breads"
        :key="index"
        v-text="
          index < breads.length - 1
            ? bread + ' / '
            : bread.includes('_')
            ? separador(breads)
            : bread
        "
      ></div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      breads: [],
      current_url: "",
      url_base: "",
      textoAux: "",
    };
  },
  computed: {
    // Obtención de variables desde store
    ...mapState(["url_actual"]),
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiarSeccionActual"]),

    separador(texto) {
      let urlText = "";
      let me = this;

      me.textoAux = texto[texto.length - 1];

      // Si el texto contiene _ en su contenido, quiere decir que es un texto compuesto
      if (me.textoAux) {
        let textArray = me.textoAux.split(/_|-/);

        textArray.map((item) => {
          urlText = urlText + " " + item;
        });
      }

      return urlText;
    },

    // Obtención de URL actual
    getUrl() {
      let me = this;

      // Valida que la variable current_url contiene datos
      if (me.current_url.length > 0) {
        let urls = me.current_url.split("/"); // Obtiene la url y realiza split para obtención de nombres
        me.AccionCambiarSeccionActual(urls[2]);

        // Recorre los nombres spliteados y filtra los nombres omitiendo los espacios en blanco
        me.breads = urls.filter((item, index) => {
          return index > 0 && item;
        });
      }
    },
  },
  watch: {
    // Cada vez que se actualiza la variable url_actual se actualiza el componente
    url_actual: function (nuevo) {
      this.current_url = nuevo;
      this.getUrl();
    },
  },
  mounte() {
    this.getUrl();
  },
};
</script>

<style></style>
